// features/organization/legalEntities/EntityFormPage.jsx
import { useParams, useNavigate } from "react-router-dom";

import { useState, useEffect } from "react";
import apiClient from "../../../shared/API/apiClient";

const EMPTY_FORM = {
  name: "",
  cin: "",
  pan: "",
  address: "",
  country: "",
  country_id: "",
  state: "",
  state_id: "",
  city: "",
  pincode: "",

  year_of_incorporation: "",
  email: "",
  phone: "",
  stock_exchange: "",
  paid_capital: "",

  corporate_address: "",
  corporate_city: "",
  corporate_state_id: "",
  corporate_zip: "",
  corporate_country_id: "",
};

const CIN_REGEX = /^[A-Z]{1}[0-9]{5}[A-Z]{2}[0-9]{4}[A-Z]{3}[0-9]{6}$/;
const PAN_REGEX = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

const toPayload = (form, orgId = 1, entityId = 0) => ({
  entity_id: entityId,
  entity_name: form.name,
  cin: form.cin,
  pan: form.pan,
  address: form.address,

  country_id: Number(form.country_id),
  state_id: Number(form.state_id),
  city: form.city,
  pincode: form.pincode,

  year_of_incorporation: form.year_of_incorporation,
  email: form.email,
  phone: form.phone,
  stock_exchange: form.stock_exchange,
  paid_capital: Number(form.paid_capital),

  corporate_address: form.corporate_address,
  corporate_city: form.corporate_city,
  corporate_state_id: Number(form.corporate_state_id),
  corporate_zip: form.corporate_zip,
  corporate_country_id: Number(form.corporate_country_id),

  org_id: orgId,
  is_active: true,
});

const fromRecord = (r) => ({
  name: r.entity_name ?? "",
  cin: r.cin ?? "",
  pan: r.pan ?? "",
  address: r.address ?? "",

  country: r.country ?? "",
  country_id: r.country_id ?? "",
  state: r.state ?? "",
  state_id: r.state_id ?? "",
  city: r.city ?? "",
  pincode: r.pincode ?? "",

  year_of_incorporation: r.year_of_incorporation ?? "",
  email: r.email ?? "",
  phone: r.phone ?? "",
  stock_exchange: r.stock_exchange ?? "",
  paid_capital: r.paid_capital ?? "",

  corporate_address: r.corporate_address ?? "",
  corporate_city: r.corporate_city ?? "",
  corporate_state_id: r.corporate_state_id ?? "",
  corporate_zip: r.corporate_zip ?? "",
  corporate_country_id: r.corporate_country_id ?? "",
});

const EntityFormPage = () => {
  const [form, setForm] = useState(EMPTY_FORM);

  const [errors, setErrors] = useState({});
  const [status, setStatus] = useState("idle");
  const [apiError, setApiError] = useState("");

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [corporateStates, setCorporateStates] = useState([]);

  const { id } = useParams();
  const navigate = useNavigate();

  // Edit Prefill API
// Edit Prefill using listing API
useEffect(() => {
  const loadEntityForEdit = async () => {
    if (id === "add") return;

    try {
      const res = await apiClient.get("/api/legal-entities");

      console.log("LIST API:", res.data);

      // response array nikalo
      const list =
        res.data.data ||
        res.data.entities ||
        res.data ||
        [];

      // current entity find karo
      const record = list.find(
        (item) => Number(item.entity_id) === Number(id)
      );

      console.log("FOUND RECORD:", record);

      if (record) {
        setForm(fromRecord(record));
      }
    } catch (err) {
      console.error("Edit prefill error", err);
    }
  };

  loadEntityForEdit();
}, [id]);

  const handleChange = (field) => (e) => {
    setForm((prev) => ({ ...prev, [field]: e.target.value }));

    setErrors((prev) => ({
      ...prev,
      [field]: "",
    }));
  };

  const validate = () => {
    const e = {};

    if (!form.name.trim()) e.name = "Entity name is required.";
    else if (form.name.trim().length < 3)
      e.name = "Entity name must be at least 3 characters.";

    if (!form.cin.trim()) {
      e.cin = "CIN is required.";
    } else if  (form.cin.trim() && !CIN_REGEX.test(form.cin.trim().toUpperCase()))
      e.cin = "Invalid CIN. e.g. U12345MH2020PTC123456";

    if (!form.pan.trim()) {
      e.pan = "Pan is required.";
    } else if (form.pan.trim() && !PAN_REGEX.test(form.pan.trim().toUpperCase()))
      e.pan = "Invalid PAN. e.g. AABCA1234A";

    if (!form.country_id) e.country_id = "Country is required.";
    if (!form.state_id) e.state_id = "State is required.";
    if (!form.city.trim()) e.city = "City is required.";

    if (!form.pincode.trim()) e.pincode = "Pincode is required.";

    // Address
    if (!form.address.trim()) {
      e.address = "Address is required.";
    }

    // if (!form.pincode.trim()) {
    //   e.pincode = "Pincode is required.";
    // } else if (!/^[0-9]{6}$/.test(form.pincode)) {
    //   e.pincode = "Pincode must be 6 digits.";
    // }

    // Year Of Incorporation
    if (!form.year_of_incorporation) {
      e.year_of_incorporation = "Year of incorporation is required.";
    } else if (
      form.year_of_incorporation.length !== 4 ||
      Number(form.year_of_incorporation) < 1900
    ) {
      e.year_of_incorporation = "Enter valid year.";
    }

    // Email
    if (!form.email.trim()) {
      e.email = "Email is required.";
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(form.email)) {
      e.email = "Invalid email address.";
    }

    // Phone
    if (!form.phone.trim()) {
      e.phone = "Phone number is required.";
    } else if (!/^[0-9]{10}$/.test(form.phone)) {
      e.phone = "Phone number must be 10 digits.";
    }

    // Paid Capital
    if (!form.paid_capital) {
      e.paid_capital = "Paid capital is required.";
    } else if (Number(form.paid_capital) <= 0) {
      e.paid_capital = "Paid capital must be greater than 0.";
    }

       // Stock exchange
    if (!form.stock_exchange.trim()) {
      e.stock_exchange = "Stock exchange is required.";
    }

    // Corporate Address
    if (!form.corporate_address.trim()) {
      e.corporate_address = "Corporate address is required.";
    }

    // Corporate City
    if (!form.corporate_city.trim()) {
      e.corporate_city = "Corporate city is required.";
    }

    // Corporate Country
    if (!form.corporate_country_id) {
      e.corporate_country_id = "Corporate country is required.";
    }

    // Corporate State
    if (!form.corporate_state_id) {
      e.corporate_state_id = "Corporate state is required.";
    }

    // Corporate Zip
    if (!form.corporate_zip.trim()) {
      e.corporate_zip = "Corporate zip is required.";
    } else if (!/^[0-9]{6}$/.test(form.corporate_zip)) {
      e.corporate_zip = "Corporate zip must be 6 digits.";
    }

    return e;
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) return setErrors(e);

    const user = JSON.parse(localStorage.getItem("user"));
    setStatus("loading");
    setApiError("");

    try {
  const payload = toPayload(
  form,
  user?.org_id ?? 1,
  id !== "add" ? Number(id) : 0
);

const response = await apiClient.post(
  "/api/legal-entities",
  payload
);

console.log("API RESPONSE:", response);

if (response.status === 200 || response.status === 201) {
  setStatus("success");

  navigate("/dashboard/legal-entities");
} else {
  throw new Error("Save failed");
}
    } catch (err) {
      console.log("ERROR FULL:", err.response);

      const msg =
        err.response?.data?.message || err.message || "Something went wrong.";

      setApiError(msg);
      setStatus("error");
    }
  };

  //Country API
  useEffect(() => {
    const loadCountries = async () => {
      try {
        const res = await apiClient.get("/api/country-industries");
        setCountries(res.data.countries || []);
      } catch (err) {
        console.error("Country API error", err);
      }
    };

    loadCountries();
  }, []);

  //Country change handler

  const handleCountryChange = async (e) => {
    const id = e.target.value;
    const selected = countries.find((c) => c.id == id);

    setForm((prev) => ({
      ...prev,
      country: selected?.country_name || "",
      country_id: id,
      state: "",
      state_id: "",
    }));

    try {
      const res = await apiClient.get(`/api/states?country_id=${id}`);
      setStates(res.data.data || []);
    } catch (err) {
      console.error("State API error", err);
    }
  };

  //State API

  useEffect(() => {
    const loadStatesForEdit = async () => {
      if (!form.country_id) return;

      try {
        const res = await apiClient.get(
          `/api/states?country_id=${form.country_id}`
        );

        setStates(res.data.data || []);
      } catch (err) {
        console.error("State prefill error", err);
      }
    };

    loadStatesForEdit();
  }, [form.country_id]);

  //State change handler
  const handleStateChange = (e) => {
    const id = e.target.value;
    const selected = states.find((s) => s.id == id);

    setForm((prev) => ({
      ...prev,
      state_id: id,
      state: selected?.state_name || "",
    }));
  };

  const handleCorporateCountryChange = async (e) => {
    const id = e.target.value;

    setForm((prev) => ({
      ...prev,
      corporate_country_id: id,
      corporate_state_id: "",
    }));

    try {
      const res = await apiClient.get(`/api/states?country_id=${id}`);
      setCorporateStates(res.data.data || []);
    } catch (err) {
      console.error(err);
    }
  };

  const handleCorporateStateChange = (e) => {
    setForm((prev) => ({
      ...prev,
      corporate_state_id: e.target.value,
    }));
  };

  useEffect(() => {
    const loadCorporateStates = async () => {
      if (!form.corporate_country_id) return;

      try {
        const res = await apiClient.get(
          `/api/states?country_id=${form.corporate_country_id}`
        );

        setCorporateStates(res.data.data || []);
      } catch (err) {
        console.error("Corporate state prefill error", err);
      }
    };

    loadCorporateStates();
  }, [form.corporate_country_id]);

  const isLoading = status === "loading";


  return (
    <div className="dash-page">
      <div className="le-page-header">
        <div>
          <div className="dash-page-title">
            {id !== "add" ? "Edit Legal Entity" : "Add Legal Entity"}
          </div>

          <div className="dash-page-subtitle">Manage legal entity details</div>
        </div>
      </div>

      <div className="org-form-card">

  {/* Row 1 */}
  <div className="org-form-row">
    {/* Entity Name */}
    <div className="org-form-field">
      <label className="org-field-label">
        Entity Name <span className="required">*</span>
      </label>

      <input
        className={`org-field-input ${
          errors.name ? "input-error" : ""
        }`}
        placeholder="e.g. Acme Subsidiary Ltd"
        value={form.name}
        onChange={handleChange("name")}
        disabled={isLoading}
      />

      {errors.name && (
        <span className="field-error">⚠ {errors.name}</span>
      )}
    </div>

    {/* CIN */}
    <div className="org-form-field">
      <label className="org-field-label">
        CIN <span className="required">*</span>
      </label>

      <input
        className={`org-field-input ${
          errors.cin ? "input-error" : ""
        }`}
        placeholder="e.g. U12345MH2020PTC123456"
        value={form.cin}
        onChange={handleChange("cin")}
        disabled={isLoading}
      />

      {errors.cin && (
        <span className="field-error">⚠ {errors.cin}</span>
      )}
    </div>
  </div>

  {/* Row 2 */}
  <div className="org-form-row">
    {/* PAN */}
    <div className="org-form-field">
      <label className="org-field-label">
        PAN <span className="required">*</span>
      </label>

      <input
        className={`org-field-input ${
          errors.pan ? "input-error" : ""
        }`}
        placeholder="e.g. AABCA1234A"
        value={form.pan}
        onChange={handleChange("pan")}
        disabled={isLoading}
      />

      {errors.pan && (
        <span className="field-error">⚠ {errors.pan}</span>
      )}
    </div>

    {/* Address */}
    <div className="org-form-field">
      <label className="org-field-label">
        Address <span className="required">*</span>
      </label>

      <textarea
        rows={3}
        className="org-field-input"
        placeholder="e.g. 456 Industrial Area, Pune 411001"
        value={form.address}
        onChange={handleChange("address")}
        disabled={isLoading}
      />

      {errors.address && (
        <span className="field-error">⚠ {errors.address}</span>
      )}
    </div>
  </div>

  {/* Row 3 */}
  <div className="org-form-row">
    {/* Country */}
    <div className="org-form-field">
      <label className="org-field-label">
        Country <span className="required">*</span>
      </label>

      <select
        className={`org-field-input ${
          errors.country_id ? "input-error" : ""
        }`}
        value={form.country_id}
        onChange={handleCountryChange}
        disabled={isLoading}
      >
        <option value="">— Select Country —</option>

        {countries.map((c) => (
          <option key={c.id} value={c.id}>
            {c.country_name}
          </option>
        ))}
      </select>

      {errors.country_id && (
        <span className="field-error">
          ⚠ {errors.country_id}
        </span>
      )}
    </div>

    {/* State */}
    <div className="org-form-field">
      <label className="org-field-label">
        State <span className="required">*</span>
      </label>

      <select
        className={`org-field-input ${
          errors.state_id ? "input-error" : ""
        }`}
        value={form.state_id}
        onChange={handleStateChange}
        disabled={!form.country_id || isLoading}
      >
        <option value="">— Select State —</option>

        {states.map((s) => (
          <option key={s.id} value={s.id}>
            {s.state_name}
          </option>
        ))}
      </select>

      {errors.state_id && (
        <span className="field-error">
          ⚠ {errors.state_id}
        </span>
      )}
    </div>
  </div>

  {/* Row 4 */}
  <div className="org-form-row">
    {/* City */}
    <div className="org-form-field">
      <label className="org-field-label">
        City <span className="required">*</span>
      </label>

      <input
        className={`org-field-input ${
          errors.city ? "input-error" : ""
        }`}
        value={form.city}
        onChange={handleChange("city")}
        disabled={isLoading}
      />

      {errors.city && (
        <span className="field-error">⚠ {errors.city}</span>
      )}
    </div>

    {/* Pincode */}
    <div className="org-form-field">
      <label className="org-field-label">
        Pincode <span className="required">*</span>
      </label>

      <input
        className={`org-field-input ${
          errors.pincode ? "input-error" : ""
        }`}
        value={form.pincode}
        onChange={handleChange("pincode")}
        disabled={isLoading}
      />

      {errors.pincode && (
        <span className="field-error">
          ⚠ {errors.pincode}
        </span>
      )}
    </div>
  </div>

  {/* Row 5 */}
  <div className="org-form-row">
    {/* Year */}
    <div className="org-form-field">
      <label className="org-field-label">
        Year Of Incorporation <span className="required">*</span>
      </label>

      <input
        type="number"
        className="org-field-input"
        value={form.year_of_incorporation}
        onChange={handleChange("year_of_incorporation")}
      />

      {errors.year_of_incorporation && (
        <span className="field-error">
          ⚠ {errors.year_of_incorporation}
        </span>
      )}
    </div>

    {/* Email */}
    <div className="org-form-field">
      <label className="org-field-label">
        Email <span className="required">*</span>
      </label>

      <input
        type="email"
        className="org-field-input"
        value={form.email}
        onChange={handleChange("email")}
      />

      {errors.email && (
        <span className="field-error">⚠ {errors.email}</span>
      )}
    </div>
  </div>

  {/* Row 6 */}
  <div className="org-form-row">
    {/* Phone */}
    <div className="org-form-field">
      <label className="org-field-label">
        Phone <span className="required">*</span>
      </label>

      <input
        className="org-field-input"
        value={form.phone}
        onChange={handleChange("phone")}
      />

      {errors.phone && (
        <span className="field-error">⚠ {errors.phone}</span>
      )}
    </div>

    {/* Stock Exchange */}
    <div className="org-form-field">
      <label className="org-field-label">
        Stock Exchange <span className="required">*</span>
      </label>

      <input
        className="org-field-input"
        value={form.stock_exchange}
        onChange={handleChange("stock_exchange")}
      />

      {errors.stock_exchange && (
        <span className="field-error">
          ⚠ {errors.stock_exchange}
        </span>
      )}
    </div>
  </div>

  {/* Row 7 */}
  <div className="org-form-row">
    {/* Paid Capital */}
    <div className="org-form-field">
      <label className="org-field-label">
        Paid Capital <span className="required">*</span>
      </label>

      <input
        type="number"
        className="org-field-input"
        value={form.paid_capital}
        onChange={handleChange("paid_capital")}
      />

      {errors.paid_capital && (
        <span className="field-error">
          ⚠ {errors.paid_capital}
        </span>
      )}
    </div>

    {/* Corporate City */}
    <div className="org-form-field">
      <label className="org-field-label">
        Corporate City <span className="required">*</span>
      </label>

      <input
        className="org-field-input"
        value={form.corporate_city}
        onChange={handleChange("corporate_city")}
      />

      {errors.corporate_city && (
        <span className="field-error">
          ⚠ {errors.corporate_city}
        </span>
      )}
    </div>
  </div>

  {/* Row 8 */}
  <div className="org-form-row">
    {/* Corporate Country */}
    <div className="org-form-field">
      <label className="org-field-label">
        Corporate Country <span className="required">*</span>
      </label>

      <select
        className="org-field-input"
        value={form.corporate_country_id}
        onChange={handleCorporateCountryChange}
      >
        <option value="">Select Country</option>

        {countries.map((c) => (
          <option key={c.id} value={c.id}>
            {c.country_name}
          </option>
        ))}
      </select>

      {errors.corporate_country_id && (
        <span className="field-error">
          ⚠ {errors.corporate_country_id}
        </span>
      )}
    </div>

    {/* Corporate State */}
    <div className="org-form-field">
      <label className="org-field-label">
        Corporate State <span className="required">*</span>
      </label>

      <select
        className="org-field-input"
        value={form.corporate_state_id}
        onChange={handleCorporateStateChange}
      >
        <option value="">Select State</option>

        {corporateStates.map((s) => (
          <option key={s.id} value={s.id}>
            {s.state_name}
          </option>
        ))}
      </select>

      {errors.corporate_state_id && (
        <span className="field-error">
          ⚠ {errors.corporate_state_id}
        </span>
      )}
    </div>
  </div>

  {/* Row 9 */}
  <div className="org-form-row">
    {/* Corporate Zip */}
    <div className="org-form-field">
      <label className="org-field-label">
        Corporate Zip <span className="required">*</span>
      </label>

      <input
        className="org-field-input"
        value={form.corporate_zip}
        onChange={handleChange("corporate_zip")}
      />

      {errors.corporate_zip && (
        <span className="field-error">
          ⚠ {errors.corporate_zip}
        </span>
      )}
    </div>

    {/* Empty */}
    <div className="org-form-field" />
  </div>

  {/* Corporate Address */}
  <div className="org-form-row">
    <div className="org-form-field">
      <label className="org-field-label">
        Corporate Address <span className="required">*</span>
      </label>

      <textarea
        rows={3}
        className="org-field-input"
        value={form.corporate_address}
        onChange={handleChange("corporate_address")}
      />

      {errors.corporate_address && (
        <span className="field-error">
          ⚠ {errors.corporate_address}
        </span>
      )}
    </div>

    <div className="org-form-field" />
  </div>

  <div className="org-form-divider" />

  <div className="org-form-actions">
    {apiError && (
      <span className="org-save-error">
        ✕ {apiError}
      </span>
    )}

    <button
      className="org-btn-cancel"
      onClick={() => navigate("/dashboard/legal-entities")}
    >
      Cancel
    </button>

    <button
      className="org-btn-save"
      onClick={handleSubmit}
      disabled={status === "loading"}
    >
      {status === "loading"
        ? "Saving..."
        : id !== "add"
        ? "Update"
        : "Add"}
    </button>
  </div>
</div>
    </div>
  );
};

export default EntityFormPage;
